@if(featureDynamicService.donationTeaser && breakpointService.breakpoint() !== 'DESKTOP'){
<app-donation></app-donation>
}
@if(!(currentRouteService.currentRoute$ | async)?.startsWith('/auth') && !(currentRouteService.currentRoute$ |
async)?.startsWith('/member') && !(currentRouteService.currentRoute$ | async)?.startsWith('/wetter-aushang') &&
!(currentRouteService.currentRoute$ | async)?.startsWith('/kontakt/') && !(currentRouteService.currentRoute$ |
async)?.startsWith('/member-support') && !(currentRouteService.currentRoute$ |
async)?.startsWith('/ref')   && !(currentRouteService.currentRoute$ |
async)?.startsWith('/regatta/twilight-races') && !(currentRouteService.currentRoute$ |
async)?.startsWith('/regatta/race-track') && !(currentRouteService.currentRoute$ |
async)?.startsWith('/regatta/hall-of-fame') && !(currentRouteService.currentRoute$ |
async)?.startsWith('/club/ausbildung') && !(currentRouteService.currentRoute$ |
async)?.startsWith('/videos') && !(currentRouteService.currentRoute$ |
async)?.startsWith('/boote/eissegeln')) {
<div class="carouselOutlet">
    <router-outlet name="carousel"></router-outlet>
</div>
}


<div class="app-content-backdrop">
    <div class="app-content">
        <!-- @defer (on immediate;) { -->
        @if(breakpointService.breakpoint() !== 'MOBILE' && !(currentRouteService.currentRoute$ |
        async)?.startsWith('/wetter-aushang')) {
        <app-menu-bar></app-menu-bar>
        }
        <!-- } @placeholder {
        <div></div>
        } -->
        <div class="fab-container" role="group" aria-label="Floating action button">
            <!-- @defer (on viewport;) { -->
            <app-application-fab-content />
            <!-- } @placeholder {
            <div></div>
            } -->
        </div>
        <div class="app-row">
            <!-- <app-nav-main *ngIf="(breakpointService.breakpoint$ | async) === 'DESKTOP'" class="app-nav-panel"></app-nav-main> -->
            <!-- flexible space, on DESKTOP only-->
            <div class="ystmLeftContent"></div>

            <div class="ystmMainContent">
                <router-outlet></router-outlet>
            </div>
            <!-- flexible space, on DESKTOP only-->
            <div class="ystmLeftContent"></div>

            <!-- right side information panel on  DESKTOP only-->
            @if(!(currentRouteService.currentRoute$ | async)?.startsWith('/member') &&
            !(currentRouteService.currentRoute$ | async)?.startsWith('/wetter-aushang')) {
            <div class="app-info-panel">
                <!-- @defer (on viewport;) { -->
                <app-application-info-panel />
                <!-- } @placeholder {
                <div></div>
                } -->
            </div>
            }
        </div>
    </div>

</div>